module.exports = __webpack_public_path__ + "static/media/html.676e8188.svg";